export const FIELD_TYPE_LABELS: Record<string, string> = {
  text_short: 'Texto Curto',
  text_long: 'Texto Longo',
  list: 'Lista',
  combo: 'Combo',
  file: 'Arquivo',
  files: 'Múltiplos Arquivos',
  date: 'Data',
  period: 'Período',
  link: 'Link',
  user: 'Usuário',
  analyst: 'Usuário Analista',
  approver: 'Aprovador',
  contract_manager_approver: 'Aprovador/Gerente do Contrato',
  group: 'Grupo de Usuário',
  integer: 'Número Inteiro',
  decimal: 'Número Decimal',
  currency: 'Financeiro',
  calculation: 'Cálculo',
  technical_proposal_review: 'Análise Técnica de Proposta',
  supplier_selection: 'Fornecedores Sugeridos',
  table: 'Tabela',
  platform_document: 'Documento da Plataforma',
  check: 'Caixa de seleção',
};

export function getFieldTypeLabel(type: string): string {
  return FIELD_TYPE_LABELS[type] || type;
}
